import React from 'react';
import { useIntl } from 'react-intl';

import Typography from '@mui/material/Typography';
import Skeleton from '../Skeleton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import DetailItem from '../DetailItem';

import { createStatuses } from 'pages/dokkaPay/pages/configurations/company/pages/paymentProviders/components/Providers/components/Provider/styled';

interface AccountDetailsData {
  ownerFullName?: string;
  status?: string;
  primaryCurrency?: string;
  preparationDays?: number | string;
}

interface AccountDetailsProps {
  data?: AccountDetailsData | null;
  isLoading: boolean;
}

const AccountDetails: React.FC<AccountDetailsProps> = ({ data, isLoading }) => {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={500}>
        {formatMessage({
          id: 'configurations.company.paymentProviders.detailsModal.details.title',
          defaultMessage: 'Account Details',
        })}
      </Typography>
      {isLoading ? (
        <Skeleton />
      ) : (
        <Stack direction="column" mt={1} spacing={1} width="100%">
          <DetailItem
            title={formatMessage({
              id: 'configurations.company.paymentProviders.detailsModal.details.accountOwner',
              defaultMessage: 'Account Owner',
            })}
            value={data?.ownerFullName}
          />
          <DetailItem
            title={formatMessage({
              id: 'configurations.company.paymentProviders.detailsModal.details.status',
              defaultMessage: 'Status',
            })}
            value={data?.status ? createStatuses[data.status] : undefined}
          />
          <DetailItem
            title={formatMessage({
              id: 'configurations.company.paymentProviders.detailsModal.details.primaryCurrency',
              defaultMessage: 'Primary Currency',
            })}
            value={data?.primaryCurrency}
          />
          <DetailItem
            title={formatMessage({
              id: 'configurations.company.paymentProviders.detailsModal.details.preparationDays',
              defaultMessage: 'Min. Preparation Days',
            })}
            value={data?.preparationDays}
          />
        </Stack>
      )}
    </Box>
  );
};

export default AccountDetails;
